import moment from "moment"
import { Timeline, TimelineProps } from "antd"

import { ICardDeliveryTabLogs } from "./types"
import { IFinalityCardLogs } from "@api/finality/state.types"

import { Empty, Flex } from "@ui/index"
import imgEmty from '@img/empty.svg'
import { IconClock } from "@img/icons"


/** Вкладка логов */
export const CardDeliveryTabLogs = ({ logsList }: ICardDeliveryTabLogs) => {
    let nextIndex = 0
    const itemsTimeline: TimelineProps['items'] = []

    const getActions = (index: number, list: IFinalityCardLogs[], currentItem: IFinalityCardLogs) => {
        return <>
            <p style={{ display: `${list[index].dataBaseName !== currentItem.dataBaseName ? 'block' : 'none'}` }}>БД сайта 👉 {currentItem.dataBaseName}</p>
            <p style={{ display: `${list[index].contractDate !== currentItem.contractDate ? 'block' : 'none'}` }}>Дата договора 👉 {currentItem.contractDate}</p>
            <p style={{ display: `${list[index].contractNumber !== currentItem.contractNumber ? 'block' : 'none'}` }}>Номер договора 👉 {currentItem.contractNumber}</p>
            <p style={{ display: `${list[index].contractTypeName !== currentItem.contractTypeName ? 'block' : 'none'}` }}>Тип договора 👉 {currentItem.contractTypeName}</p>
            <p style={{ display: `${list[index].contractViewName !== currentItem.contractViewName ? 'block' : 'none'}` }}>Вид договора 👉 {currentItem.contractViewName}</p>
            <p style={{ display: `${list[index].contractStatusName !== currentItem.contractStatusName ? 'block' : 'none'}` }}>Статус договора 👉 {currentItem.contractStatusName}</p>
            <p style={{ display: `${list[index].companyNameShort !== currentItem.companyNameShort ? 'block' : 'none'}` }}>Контрагент 👉 {currentItem.companyNameShort}</p>
            <p style={{ display: `${list[index].companyContactFIO !== currentItem.companyContactFIO ? 'block' : 'none'}` }}>Контактное лицо 👉 {currentItem.companyContactFIO}</p>
            <p style={{ display: `${list[index].companyContactPhone !== currentItem.companyContactPhone ? 'block' : 'none'}` }}>Телефон контрагента 👉 {currentItem.companyContactPhone}</p>
            <p style={{ display: `${list[index].companyContactEmail !== currentItem.companyContactEmail ? 'block' : 'none'}` }}>Email контрагента 👉 {currentItem.companyContactEmail}</p>
            <p style={{ display: `${list[index].deliveryToWhom !== currentItem.deliveryToWhom ? 'block' : 'none'}` }}>Кому доставить 👉 {currentItem.deliveryToWhom}</p>
            <p style={{ display: `${list[index].deliveryAddress !== currentItem.deliveryAddress ? 'block' : 'none'}` }}>Адрес доставки 👉 {currentItem.deliveryAddress}</p>
            <p style={{ display: `${list[index].isLearningOutsideMoodle !== currentItem.isLearningOutsideMoodle ? 'block' : 'none'}` }}>Вне LMS 👉 {currentItem.isLearningOutsideMoodle}</p>
            <p style={{ display: `${list[index].comment !== currentItem.comment ? 'block' : 'none'}` }}>Комментарий 👉 {currentItem.comment}</p>
            <p>Нажата кнопка сохранить</p>
        </>
    }

    return <>
        {logsList.value.length === 0
            ? <Empty image={imgEmty} title="Логи отсутствуют" />
            : logsList.value.forEach((item, index) => {
                if ((logsList.value.length - 1) === index) { nextIndex = index } else { nextIndex += 1 }

                return <>
                    {itemsTimeline.push({
                        loading: index === 0 ? true : false,

                        icon: (logsList.value.length === (index + 1)) ? <IconClock width="18px" height="18px" color="green" /> : '',

                        title: <>
                            <p>{item.logAction === 'INSERT' ? 'Договор создан' : 'Договор изменён'}</p>
                            <div>{item.logOperator === 'Системой'
                                ? <Flex gap="4px" flexDirection="row" justifyContent="flex-end">
                                    <b>Кем:</b>
                                    <p>Системой</p>
                                </Flex>
                                : <Flex gap="4px" flexDirection="row" justifyContent="flex-end">
                                    <b>Кем:</b>
                                    <p>{item.logOperator}</p>
                                </Flex>
                            }</div>

                            <Flex gap="4px" flexDirection="row" justifyContent="flex-end">
                                <b>Когда:</b>
                                <p>{moment(item.logDate).format('DD.MM.YYYY HH:mm:ss')}</p>
                            </Flex>
                        </>,

                        content: <div>
                            {item.logAction === 'INSERT'
                                ? 'Договор зарегистрирован'
                                : getActions(nextIndex, logsList.value, item)
                            }
                        </div>
                    })}
                </>
            })
        }

        <Timeline items={itemsTimeline} className="fontStyle" style={{ fontWeight: '500' }} />
    </>
}